// store/modules/auth.js
const state = {
  authUserData: {
    name: '',
    surName: '',
    email: ''
  }
}

const getters = {
  getAuthUserData: (state) => {
    // Пытаемся получить данные из localStorage, если нет - из state
    const storedData = localStorage.getItem('authUserData')
    if (storedData) {
      return JSON.parse(storedData)
    }
    return state.authUserData
  }
}

const mutations = {
  SET_AUTH_USER_DATA(state, userData) {
    state.authUserData = {
      ...state.authUserData,
      ...userData
    }

    // Сохраняем в localStorage
    localStorage.setItem('authUserData', JSON.stringify(state.authUserData))
  },

  // Дополнительная мутация для очистки (на случай logout)
  CLEAR_AUTH_USER_DATA(state) {
    state.authUserData = {
      name: '',
      surName: '',
      email: ''
    }
    localStorage.removeItem('authUserData')
  }
}

const actions = {
  setAuthUserData({ commit }, userData) {
    commit('SET_AUTH_USER_DATA', userData)
  },

  clearAuthUserData({ commit }) {
    commit('CLEAR_AUTH_USER_DATA')
  },

  // Action для инициализации из localStorage при загрузке приложения
  initializeAuthData({ commit }) {
    const storedData = localStorage.getItem('authUserData')
    if (storedData) {
      commit('SET_AUTH_USER_DATA', JSON.parse(storedData))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}